import {combineReducers} from 'redux';

import assign from './plan-assign/reducer';
import index from './plans-index/reducer';
import instance from './plan-instance/reducer';

export default combineReducers({assign, index, instance});
